import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { isNumeric } from '../../utils/Numeric';
import { confirmEnding } from '../../utils/String';

import {
  message, Modal,
  Affix,
  Checkbox, Select, Button,
} from 'antd';
import {
  UploadOutlined,
  ExclamationCircleOutlined,
  CheckCircleTwoTone,
  DiffOutlined,
  SyncOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';

import { Page } from '../../components';
import { insertSpecs, getGoodsBySpecName as getGoodsTableBySpecName } from '../../services/Goods';
import { insertGoods, insertGoodsPrice } from '../../services/Buyer';
import { getDatetime } from '../../services/Login';
export default React.forwardRef((props, ref) => {
  const { isPreAdd, importMode, type, suppliers, buyers, buyerId, buyerGoodsCode, onCloseCallback, buyerGoods, getBuyerGoods, onImportOrderGoods, buyerIsBatchDelivery, buyerDeliveryDeadlineDates } = props;

  const [fileName, setFileName] = useState('');
  const [rows, setRows] = useState([]);

  const [isShowSyncDb, setShowSyncDb] = useState(false);
  const [datetime, setDatetime] = useState(undefined);

  const [isChecking, setChecking] = useState(false);
  const [isSyncing, setSyncing] = useState(false);
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    getDatetime().then(data => setDatetime(data));
  }, []);

  const onSaveCallback = (goods, callback) => {
    try {
      const key = 'insert goods spec';
      const temp = [].concat(rows);

      const insertArr = [];
      goods.forEach(x => {
        const find = insertArr.find(y => y.goods_id === x.goods_id);
        if (find) {
          find.specs.push(x);
        } else {
          insertArr.push({
            goods_id: x.goods_id,
            specs: [x]
          });
        }
      });

      const arr = [];
      insertArr.forEach(x => {
        arr.push(
          new Promise((resolve, reject) => {
            insertSpecs(x.goods_id, x.specs).then(data => {
              message.loading({ content: `正在同步${x.goods_name}...`, key });
              x.specs.forEach(ss => {
                temp[ss.idx]._status = 2;
              });
              resolve(true)
            })
          })
        );
      });

      Promise.all(arr).then(values => {
        message.success({ content: `产品库添加完成 [ ${values.length}] 条数据  `, key, duration: 2 });
        callback && callback();
      });
    } catch (e) {

    }
  }



  const syncBuyerDB = async () => {
    setSyncing(true);
    const key = 'update_goods';
    const temp = [].concat(rows);
    const insert = temp.filter(x => x._status === 2).map(y => ({
      idx: y._idx,
      goods_spec_name: y._goods_spec_name,
      buyer_id: buyerId,
      goods_id: y._goods_id,
      goods_spec_id: y._goods_spec_id,
      pcs_per_carton: y.pcs_per_carton,
      price: y._price,
      start_time: datetime,
      end_time: '2099-12-31 23:59:59'
    }));
    const insert1 = temp.filter(x => x._status === 3 || x._status === 5).map(y => ({
      idx: y._idx,
      goods_spec_name: y._goods_spec_name,
      buyer_id: buyerId,
      goods_id: y._goods_id,
      goods_spec_id: y._goods_spec_id,
      pcs_per_carton: y.pcs_per_carton,
      price: y._price,
      start_time: datetime,
      end_time: '2099-12-31 23:59:59'
    }));


    if (insert.length > 0) {
      insertGoods(buyerId, insert).then(data => {
        const arr = [];
        insert.forEach((x, i) => {
          arr.push(
            new Promise(async (resolve, reject) => {
              return insertGoodsPrice(buyerId, x.goods_id, x.goods_spec_id, x).then(data2 => {
                message.loading({ content: `正在同步${x.goods_spec_name}...`, key });
                temp[x.idx]._status = 0;
                resolve(true);
              });
            })
          );
        });

        insert1.forEach((x, i) => {
          arr.push(
            new Promise(async (resolve, reject) => {
              try {
                await insertGoodsPrice(buyerId, x.goods_id, x.goods_spec_id, x).then(data => {
                  message.loading({ content: `正在同步${x.goods_spec_name}...`, key });
                  temp[x.idx]._status = 0;
                  resolve(true);
                });
              } catch (e) {
                resolve(false);
              }
            })
          );
        });
        Promise.all(arr).then(values => {
          message.success({ content: `同步完成 [ ${values.length}] 条数据 `, key, duration: 1 });
          getBuyerGoods(() => setRows(temp));
          setSyncing(false);
        });
      });
    } else if (insert.length === 0) {
      const arr = [];
      insert1.forEach((x, i) => {
        arr.push(
          new Promise(async (resolve, reject) => {
            try {
              await insertGoodsPrice(buyerId, x.goods_id, x.goods_spec_id, x).then(data => {
                message.loading({ content: `正在同步${x.goods_spec_name}...`, key });
                temp[x.idx]._status = 0;
                resolve(true);
              });
            } catch (e) {
              resolve(false);
            }
          })
        );
      });
      Promise.all(arr).then(values => {
        message.success({ content: `同步完成 [ ${values.length}] 条数据 `, key, duration: 1 });
        getBuyerGoods(() => setRows(temp));
        setSyncing(false);
      });
    } else {

    }
  }


  const onImportExcel = file => {
    // 获取上传的文件对象
    const { files } = file.target;
    if (files.length === 0) return;
    setFileName(files[0].name);

    // 通过FileReader对象读取文件
    const fileReader = new FileReader();
    fileReader.onload = event => {
      try {
        const { result } = event.target;

        // 以二进制流方式读取得到整份excel表格对象
        const workbook = XLSX.read(result, { type: 'binary' });
        // 存储获取到的数据
        let data = [];
        // 遍历每张工作表进行读取（这里默认只读取第一张表）
        for (const sheet in workbook.Sheets) {
          // esline-disable-next-line
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            // 利用 sheet_to_json 方法将 excel 转成 json 数据
            console.log(sheet)
            data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
            setRows(data);
            break; // 如果只取第一张表，就取消注释这行
          }
        }

        // 最终获取到并且格式化后的 json 数据
        message.success('导出文件完成！')
        console.log(data);
      } catch (e) {
        // 这里可以抛出文件类型错误不正确的相关提示
        message.error('文件类型不正确！');
      }
    };
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(files[0]);
  }

  const columns = [];
  const colWidths = [50, 120, 240, 120, 60, 60, 100, 120, 60];
  if (rows.length > 0) {
    for (let i=0; i< 9 + buyers.length*3 + suppliers.length; i++)
      columns.push("Col"+i);
  }
  const parseHeader = () => {
    const tds = [];
    columns.forEach((x,i) => {
      tds.push(<th>{x}</th>);
    })
    return <tr>{tds}</tr>
  }

  const parseRow = (row, i) => {
    const tds = [];
    columns.forEach(x => {
      tds.push(<td className="td">{row[x]}</td>);
    })
    return <tr>{tds}</tr>
  }


  return (
    <div className='goods-import-container'>
      <div className="goods-import-button-group">
        <div className='goods-import-file-name'> {fileName} </div>
        <div icon={<UploadOutlined />} className='upload-wrap'>
          <input className='file-uploader' type='file' accept='.xlsx, .xls' onChange={onImportExcel} />
          <span className='upload-text'>选择文件...</span>
        </div>
        <div className='upload-tip'>支持 .xlsx、.xls文件</div>
        {rows.filter(x => x._status > 0).length > 0 && <div style={{ fontSize: '1.5rem', marginLeft: 'auto' }}>比对结果: 共有[<span style={{ color: 'red' }}><strong>{rows.filter(x => x._status > 0).length}</strong></span>]条数据不一致，请查证后重新比对导入</div>}
        {(rows.filter(x => x._status > 0).length === 0 && isChecked) && <div style={{ fontSize: '1.5rem', marginLeft: 'auto' }}>比对结果: [<span style={{ color: 'green' }}><strong>成功</strong></span>],可以导入到订单</div>}
      </div>
      
      <div className="goods-import-content">
        <table className="goods-import-all-table" border="1" >
          {
            rows.length > 0 && parseHeader(rows[0])
          }
          {
            rows.map((x, i) => parseRow(x, i))
          }
        </table>
      </div>
    </div >
  );
});